import { type ReactNode } from 'react';
import { enableGlobalNavIaRedesign, enableNewNavigation } from '@gonfalon/dogfood-flags/dogfood-flags';
import { useSlots } from '@gonfalon/react/useSlots';
import clsx from 'clsx';

import { Breadcrumbs } from '../../Breadcrumbs';
import { SidebarToggle, useSidebarContext } from '../../Sidebar';

import styles from './LayoutHeader.module.css';

export function LayoutHeader({
  children,
  className,
  layoutHeaderLocationClassName,
  isMaxWidthAndCentered,
}: {
  children?: ReactNode;
  className?: string;
  layoutHeaderLocationClassName?: string;
  isMaxWidthAndCentered?: boolean;
}) {
  const [{ actions, context }] = useSlots(children, {
    actions: LayoutHeaderActions,
    context: LayoutHeaderContext,
  });

  return (
    <div className={clsx(styles.header, className, { [styles.maxWidthAndCentered]: isMaxWidthAndCentered })}>
      <LayoutHeaderLocation className={layoutHeaderLocationClassName}>{context}</LayoutHeaderLocation>
      {actions}
    </div>
  );
}

export function LayoutHeaderContext({ children }: { children: ReactNode }) {
  return children;
}

function LayoutHeaderLocation({ className, children }: { className?: string; children?: ReactNode }) {
  const sidebar = useSidebarContext();
  const isNewNavigationEnabled = enableNewNavigation();
  const redesign = enableGlobalNavIaRedesign();
  const sidebarShown = sidebar.isVisible || sidebar.isRail;

  return (
    <div className={clsx(styles.location, { [styles.newNavLocation]: isNewNavigationEnabled }, className)}>
      {!isNewNavigationEnabled && (
        <div className={styles.toggle} aria-hidden={sidebarShown ? 'true' : undefined} inert={sidebarShown}>
          <SidebarToggle {...(redesign ? { 'data-sidebar-toggle': 'header' } : {})} />
        </div>
      )}
      {children ?? <Breadcrumbs />}
    </div>
  );
}

export function LayoutHeaderActions({ children }: { children: ReactNode }) {
  return <div className={styles.actions}>{children}</div>;
}
